import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function ArticleHighlights() {
  const articles = getFeaturedArticles();

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            追剧攻略
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            最新剧评、追剧攻略、行业观察，让你更懂剧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {articles.slice(0, 4).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-primary-500/10 text-primary-400 mb-2 whitespace-nowrap">
                  {article.categoryName}
                </span>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors duration-300 line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-600">
                  <span>{article.publishDate}</span>
                  <span>{article.readCount.toLocaleString()} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/article/article-001"
            className="inline-flex items-center gap-1 px-5 py-2.5 rounded-lg bg-background-100 border border-background-200/60 text-sm text-foreground-300 hover:text-primary-400 hover:border-primary-500/30 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            查看更多攻略
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}